import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConfirmationFlowState } from '../models/state.model';

export const selectConfirmationFlowState = createFeatureSelector<ConfirmationFlowState>('confirmationFlow');

export const selectStatementDetails = createSelector(
  selectConfirmationFlowState,
  (state) => ({
    confirmationId: state.confirmationId ?? '',
    interestedParty: state.interestedParty ?? false,
    confirmationDate: state.confirmationDate,
    description: state.description
  })
);

export const selectRecipient = createSelector(
  selectConfirmationFlowState,
  (state) => state.recipient
);

export const selectStepIndicatorIndex = createSelector(
  selectConfirmationFlowState,
  (state) => state.stepIndicatorIndex
);
